// extracted by mini-css-extract-plugin
export default {"navLink":"style_navLink__a-IHH","navLinkActive":"style_navLinkActive__5SiXD"};